<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'user', params: {} }">
            User
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'userView', params: {} }">
              View User
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View User
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="user.firstName">
            <td max-width="35%" class="text-subtitle-1">First Name:</td>
            <td>{{ user.firstName }}</td>
          </tr>
          
          <tr v-if="user.lastName">
            <td max-width="35%" class="text-subtitle-1">Last Name:</td>
            <td>{{ user.lastName }}</td>
          </tr>
          
          <tr v-if="user.username">
            <td max-width="35%" class="text-subtitle-1">User Name:</td>
            <td>{{ user.username }}</td>
          </tr>
          
          <tr v-if="user.phone">
            <td max-width="35%" class="text-subtitle-1">Phone:</td>
            <td>{{ user.phone }}</td>
          </tr>
          
          <tr v-if="user.email">
            <td max-width="35%" class="text-subtitle-1">Email:</td>
            <td>{{ user.email }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getUser } from "@/services/user";
    

    export default {
      data() {
        return {
            id: '',
            user: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "userEdit", params: { id: id }});
        },
        setInstace() {
          this.setDependencies().then( () => {
            getUser(this.id)
            .then((response) => {
              this.user = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading user");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstace();
        this.$emit("showParent", false);
      }
    }
    </script>
    